import { mediaQueryAsync } from 'helpers/graphql'
import { fetchInstantNewsSourceGroupSuccess } from './actions';

export const fetchSourceGroupTasks = (data) => {
  const query = `
    query(
      $offset: Int
      $ids: [ID]
      $mediaType:String
      $name: String
      $label: String
    ) {
      sourceGroups(
        limit: 999
        offset: $offset
        ids: $ids
        mediaType: $mediaType
        name: $name
        label: $label
      ) {
        count
        data {
          id
          name
          mediaType
          description
          sources
          labels
        }
      }
    }
  `
  return mediaQueryAsync(query, data)
  .then((body) =>
    fetchInstantNewsSourceGroupSuccess(body.data.sourceGroups.data)
  );
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/tasks.js
 **/